exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-dd8bcb64] a {\n  color: inherit;\n}\n[data-v-dd8bcb64] a:hover {\n    text-decoration: underline;\n}\n", ""]);

